import React from "react";
import HomePage from "pages/home";
import CardPage from "pages/card";

const routesCampaign = [
  {
    path: "/#guide",
    name: "GIỚI THIỆU",

    element: <HomePage />,
  },
  {
    path: "/#joinNow",
    name: "QUY ĐỊNH",

    element: <HomePage />,
  },
  {
    path: "/",
    name: "TRANG CHỦ",

    element: <HomePage />,
  },
  {
    path: "/card",
    name: "TRANG CHỦ",

    element: <CardPage />,
  },
];

export default routesCampaign;
